import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { SearchFieldMapping } from '../interfaces/builder-screen.models';

export interface FieldMappingTarget {
  dataPath: string;
  label: string;
}

@Component({
  selector: 'app-field-mapping-modal',
  templateUrl: './field-mapping-modal.component.html',
  styleUrls: ['./field-mapping-modal.component.scss'],
  standalone: false
})
export class FieldMappingModalComponent implements OnInit {
  /** Nome da entidade do search (para referência visual) */
  entityName = '';

  /** Se o campo de origem é um search/querySelect (true) ou outro tipo (false) */
  isSearchField = true;

  /** Campos do formulário disponíveis como destino */
  availableTargets: FieldMappingTarget[] = [];

  /** Mapeamentos já configurados */
  existingMappings: SearchFieldMapping[] = [];

  /** Lista de itens editáveis */
  items: Array<{
    sourceColumn: string;
    targetDataPath: string;
    targetLabel: string;
  }> = [];

  constructor(private modal: NzModalRef) {}

  ngOnInit(): void {
    if (this.existingMappings?.length > 0) {
      this.items = this.existingMappings.map(m => ({
        sourceColumn: m.sourceColumn || '',
        targetDataPath: m.targetDataPath,
        targetLabel: m.targetLabel || ''
      }));
    }
  }

  addMapping(): void {
    this.items.push({
      sourceColumn: '',
      targetDataPath: '',
      targetLabel: ''
    });
  }

  removeMapping(index: number): void {
    this.items.splice(index, 1);
  }

  onTargetChange(item: any): void {
    const target = this.availableTargets.find(t => t.dataPath === item.targetDataPath);
    if (target) {
      item.targetLabel = target.label;
    }
  }

  get validCount(): number {
    if (this.isSearchField) {
      return this.items.filter(i => i.sourceColumn && i.targetDataPath).length;
    }
    return this.items.filter(i => i.targetDataPath).length;
  }

  handleOk(): void {
    const result: SearchFieldMapping[] = this.items
      .filter(i => this.isSearchField ? (i.sourceColumn && i.targetDataPath) : !!i.targetDataPath)
      .map(i => {
        const mapping: SearchFieldMapping = {
          targetDataPath: i.targetDataPath,
          targetLabel: i.targetLabel || ''
        };
        if (this.isSearchField && i.sourceColumn) {
          mapping.sourceColumn = i.sourceColumn.trim();
        }
        return mapping;
      });
    this.modal.close(result);
  }

  handleCancel(): void {
    this.modal.close(undefined);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
